import validate from "/Users/air/Projects/EMCI/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/air/Projects/EMCI/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  cors: () => import("/Users/air/Projects/EMCI/middleware/cors.js")
}